import { useEffect } from 'react';
import { useAppContext } from '@/context/AppContext';

export function useLanguageSwap(durationMs: number = 300) {
  const {
    language,
    isChangingLanguage,
    previousLanguage,
    setIsChangingLanguage,
    setPreviousLanguage,
  } = useAppContext();

  useEffect(() => {
    setIsChangingLanguage(false);
    setPreviousLanguage(language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (language !== previousLanguage) {
      setIsChangingLanguage(true);
      const t = setTimeout(() => {
        setPreviousLanguage(language);
        setIsChangingLanguage(false);
      }, durationMs);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [language, previousLanguage, setIsChangingLanguage, setPreviousLanguage, durationMs]);

  return { isChangingLanguage };
}


